import { HStack, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import packageJson from '../../../../package.json'

import * as S from './styled'

export const Footer = () => {
  const navigate = useNavigate()
  const version = packageJson.version

  const donateClick = () => {
    window.open('https://pages.donately.com/sethcarrino/form/frm_2411b071ed1d', '_blank')
  }

  const feedbackRedirect = () => {
    const mailLink = document.createElement('a')
    const subject = 'Feedback - Songvisor'
    const body =
      'We are writing to inform you that Songvisor could use some work with these issues:'

    mailLink.href = `mailto:sethcarrino@gmail.com?subject=${subject}&body=${body}`
    mailLink.click()
  }

  return (
    <S.Container w='100%' padding={8}>
      <HStack pb={4}>
        <S.LinkButton variant='link' onClick={() => navigate('/about')}>
          About
        </S.LinkButton>
        <S.LinkButton variant='link' onClick={donateClick}>
          Donate
        </S.LinkButton>
        <S.LinkButton variant='link' onClick={() => navigate('/faq')}>
          FAQ
        </S.LinkButton>
        <S.LinkButton variant='link' onClick={feedbackRedirect}>
          Feedback
        </S.LinkButton>
      </HStack>
      <Text
        align='center'
        fontSize='sm'
      >{`Made with ❤️ by Seth Carrino - Powered by ChatGPT-4 - v${version}`}</Text>
    </S.Container>
  )
}
